import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { lt, useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { FlagSelectField } from '@mews-commander/form';
import { LegalEnvironment, ProductClassifications } from '@mews-commander/data-access';
import { getLegalEnvironment } from '@mews-commander/legacy-entities/src/ducks/legalEnvironments';
import { ContentSection } from '@mews-commander/ui';
import { useCommanderSelector } from '@mews-commander/utils';
import { OptionsSelectField } from '../fields/OptionsSelectField';
import { PromotionsSelectField } from '../fields/PromotionsSelectField';

export const OptionsStepFields = () => {
    const { legalEnvironmentCode } = useCurrentEnterprise();
    const legalEnvironment: LegalEnvironment = useCommanderSelector((state) =>
        // @ts-expect-error, badly typed selector
        getLegalEnvironment(state, { legalEnvironmentCode })
    );

    const enableProductClassificationsInput = useFeatureFlag(FeatureFlag.enableProductClassificationsInput);

    return (
        <ContentSection title={lt('Options')} spacing="300" contentSpacing="200">
            <OptionsSelectField />
            <PromotionsSelectField />
            {enableProductClassificationsInput || legalEnvironment.allowProductClassifications ? (
                <FlagSelectField<ProductClassifications>
                    name="classifications"
                    label={lt('Classifications')}
                    flagName="ProductClassifications"
                    flagValues={['beverage', 'cityTax', 'food', 'wellness']}
                    multiselect
                />
            ) : null}
        </ContentSection>
    );
};
